import React, { Component } from "react";
import Registration from "./Registration.js";
import { constants } from "../../../utils/Constants.js";
import WebServiceConsumer from "../../../services/WebServiceConsumer.js";
import SecurityService from "../../../services/SecurityService.js";
import RegistrationValidator from "../../../validators/RegistrationValidator";
import PasswordValidator from "../../../validators/PasswordValidator";
import UserSession from "../../../session/UserSession.js";
import { paths } from "../../paths.js";
import { messages } from "../../../localization/messages.js";

const { REACT_APP_AUTHENTICATION_TYPE } = process.env;

const HttpStatus = require("http-status-codes");

class RegistrationContainer extends Component {
  constructor(props) {
    super(props);

    this.authenticationType = REACT_APP_AUTHENTICATION_TYPE;

    this.serviceConsumer = new WebServiceConsumer();
    this.securityService = new SecurityService();

    this.registrationValidator = new RegistrationValidator();
    this.passwordValidator = new PasswordValidator();

    this.messageAlert = React.createRef();

    this.state = {
      username: "",
      password: "",
      passwordConfirm: "",

      passwordRequirements: undefined,

      validation: {
        username: undefined,
        password: {
          valid: undefined,
          messages: []
        }
      },
      enablement: {
        username: true,
        password: true,
        passwordConfirm: true
      }
    };
  }

  componentDidMount() {
    this.loadServerDataForLogin();
  }

  onLogin = data => {
    UserSession.setUser(data);

    this.loadUserData();
  };

  onPasswordRequirementsLoad = data => {
    this.setState({ passwordRequirements: data });
  };

  loadServerDataForLogin() {
    this.prepareCall(
      this.securityService.getPasswordRequirements(
        this.authenticationType,
        this.onPasswordRequirementsLoad,
        this.onError
      )
    );
    this.performCalls();
  }

  onError = error => {
    this.messageAlert.current.showErrorMessage(error);
  };

  validateForm = () => {
    const formValidation = this.registrationValidator.validate(
      this.state.username,
      this.state.password,
      this.state.passwordConfirm,

      this.state.enablement
    );

    return formValidation;
  };

  updateValidation(field, update) {
    var updated = this.state.validation;
    updated[field] = update;

    this.setState({
      validation: updated
    });
  }

  validateFormData = () => {
    this.prepareCall(
      this.securityService.checkUsername(
        this.authenticationType,
        this.state.username,
        data => {
          this.updateValidation("username", true);
        },
        error => {
          this.updateValidation("username", false);
        }
      )
    );
    this.performCalls();
  };

  onChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });

    var password = this.state.password;
    var passwordConfirm = this.state.passwordConfirm;

    if (event.target.id === "password") {
      password = event.target.value;
    } else if (event.target.id === "passwordConfirm") {
      passwordConfirm = event.target.value;
    }
    this.validateFormDataInRealtime(password, passwordConfirm);
  };

  validateFormDataInRealtime(password, passwordConfirm) {
    var passwordValidation = { valid: undefined, messages: [] };
    if (password.length > 0 || passwordConfirm.length > 0) {
      passwordValidation = this.passwordValidator.validate(
        password,
        passwordConfirm,
        this.state.passwordRequirements
      );
    }

    this.updateValidation("password", passwordValidation);
  }

  onSubmit = event => {
    event.preventDefault();

    this.validateFormData();
  };

  componentDidUpdate() {
    if (this.dataValidated()) {
      this.register();
    }
  }

  dataValidated() {
    return (
      this.state.validation.username && this.state.validation.password.valid
    );
  }

  onRegister = data => {
    this.props.history.push(paths.LOGIN_PATH, {
      message: {
        status: HttpStatus.OK,
        statusText: HttpStatus.getStatusText(HttpStatus.OK),
        text: messages.registration_succes
      }
    });
  };

  register() {
    const registrationData = this.constructRegistrationData();
    this.prepareCall(
      this.securityService.register(
        registrationData,
        this.onRegister,
        this.onError
      )
    );
    this.performCalls();
  }

  constructRegistrationData() {
    return {
      username: this.state.username,
      password: this.state.password,
      passwordConfirm: this.state.passwordConfirm,

      authenticationType: this.authenticationType
    };
  }

  render() {
    return (
      <Registration
        onSubmit={this.onSubmit}
        onCancel={() => this.props.history.goBack()}
        onChange={this.onChange}
        isValid={this.validateForm}
        alertRef={this.messageAlert}
        validation={this.state.validation}
        enablement={this.state.enablement}
      />
    );
  }
}

export default RegistrationContainer;
